import { render, staticRenderFns } from "./VFormItemRangeDateTime.vue?vue&type=template&id=1bfd3d1b&"
import script from "./VFormItemRangeDateTime.vue?vue&type=script&lang=js&"
export * from "./VFormItemRangeDateTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bfd3d1b')) {
      api.createRecord('1bfd3d1b', component.options)
    } else {
      api.reload('1bfd3d1b', component.options)
    }
    module.hot.accept("./VFormItemRangeDateTime.vue?vue&type=template&id=1bfd3d1b&", function () {
      api.rerender('1bfd3d1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VFormItemRangeDateTime.vue"
export default component.exports